import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../_services/auth/auth.service';
import { ConsentManager } from '../../_services/consent/consent-manager.service';
import { ASSOCIATION } from '../../_config/association';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'app-footer',
    imports: [CommonModule],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
  private as: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  private consent: ConsentManager = inject(ConsentManager);

  association = ASSOCIATION;
  annee = new Date().getFullYear();

  get isAuth$(): Observable<boolean> {
    return this.as.isAuth$;
  }

  logout(){
    this.as.logout();
    this.router.navigateByUrl('/');
  }

  openCookiePreferences() {
    this.consent.openPreferences();
  }
}
